// extracted by mini-css-extract-plugin
module.exports = {"menu":"_1OfkvouVGB3w8ymEpPi4cU"};